// Stellarium Web - Copyright (c) 2022 - Stellarium Labs SRL
//
// This program is licensed under the terms of the GNU AGPL v3, or
// alternatively under a commercial licence.
//
// The terms of the AGPL v3 license can be found in the main directory of this
// repository.

<template>
  <!-- [guanxing patch] 底栏整合成一条（M-SW3d）：功能按钮收进同一个圆角背景
       栏；配合 gui.vue 的 uiIdle 整条自动隐藏。
       [guanxing patch] M-SW46：地点按钮（M-SW3c 本地面板）按用户需求整体下线，
       剩余按钮宽度自适应标签 + bar-shell 加 gap，不再互相重叠。 -->
  <div style="position: absolute; display:flex; align-items: flex-end; justify-content: center; width: 100%;">
    <div class="bar-shell">

    <!-- [guanxing patch] 星座连线五态循环按钮（M-SW3g 三态；M-SW15 用户需求
         把二十八宿并入循环；M-SW62 十二星次并入循环）：默认西方星座 → 按一次切
         中国星官 → 再按切二十八宿 → 再按切十二星次 → 再按关闭连线 → 循环回西方星座。
         图标沿用星座连线图标；点亮状态 = 连线可见。 -->
    <bottom-button :label="$t(constellationsLabel)"
                v-if="$store.state.showConstellationsLinesButton !== false"
                :img="require('@/assets/images/btn-cst-lines.svg')"
                img_alt="Constellations Button"
                :toggled="$store.state.stel.constellations.lines_visible"
                @clicked="cycleConstellations">
    </bottom-button>
    <!-- [guanxing patch] 视图设置菜单（M-SW7，用户需求）：大气 / 地景 / 夜视
         模式三个视图开关收进下栏单独按钮，图标沿用夜视模式图标。引擎布尔
         开关走 toggleStel（直写 $stel.core），夜视沿用 setNightMode（叠加层）。
         注意：19:00 曾被并行会话的旧编辑器缓冲覆盖回退，此为重新应用。 -->
    <v-menu :close-on-content-click="false" transition="v-slide-y-transition" offset-y top left v-model="showViewMenu">
      <template v-slot:activator="{ on }">
        <div v-on="on">
          <bottom-button :label="$t('View Settings')"
                      :img="require('@/assets/images/btn-night-mode.svg')"
                      img_alt="View Settings Button"
                      :toggled="showViewMenu">
          </bottom-button>
        </div>
      </template>
      <v-list class="secondary" dense>
        <v-list-item @click.stop="toggleStel('atmosphere.visible')">
          <v-list-item-action>
            <v-switch value :input-value="getStel('atmosphere.visible')" label=""></v-switch>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $t('Atmosphere') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item @click.stop="toggleStel('landscapes.visible')">
          <v-list-item-action>
            <v-switch value :input-value="getStel('landscapes.visible')" label=""></v-switch>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $t('Landscape') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item @click.stop="setNightMode(!$store.state.nightmode)">
          <v-list-item-action>
            <v-switch value :input-value="$store.state.nightmode" label=""></v-switch>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $t('Night Mode') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <!-- [guanxing patch] 视图设置对话框入口（M-SW7 并入，原在图层菜单）：
             银河 / 深空 / 子午线等开关在 view-settings-dialog，先关菜单再开
             对话框，避免 menu 与 dialog 两层 overlay 叠加。 -->
        <v-divider></v-divider>
        <v-list-item @click.stop="openViewSettings()">
          <v-list-item-action>
            <v-icon>mdi-settings</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $t('View Settings') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-menu>
    <!-- [guanxing patch] 低频开关收进「图层」菜单（M-SW3b；M-SW3h 加黄道线）：
         方位网格 / 赤道 Jnow 网格 / J2000 网格 / 黄道线 / 星座艺术。 -->
    <v-menu :close-on-content-click="false" transition="v-slide-y-transition" offset-y top left v-model="showLayersMenu">
      <template v-slot:activator="{ on }">
        <div v-on="on">
          <bottom-button :label="$t('Layers')"
                      :img="require('@/assets/images/btn-azimuthal-grid.svg')"
                      img_alt="Layers Button"
                      :toggled="showLayersMenu">
          </bottom-button>
        </div>
      </template>
      <v-list class="secondary" dense>
        <v-list-item @click.stop="toggleStel('lines.azimuthal.visible')">
          <v-list-item-action>
            <v-switch value :input-value="getStel('lines.azimuthal.visible')" label=""></v-switch>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $t('Azimuthal Grid') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item @click.stop="toggleStel('lines.equatorial_jnow.visible')">
          <v-list-item-action>
            <v-switch value :input-value="getStel('lines.equatorial_jnow.visible')" label=""></v-switch>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $t('Equatorial Grid') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item @click.stop="toggleStel('lines.equatorial.visible')">
          <v-list-item-action>
            <v-switch value :input-value="getStel('lines.equatorial.visible')" label=""></v-switch>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $t('Equatorial J2000 Grid') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <!-- [guanxing patch] 黄道线（M-SW3h，用户需求）：引擎 lines.ecliptic
             （FRAME_ECLIPTIC 单线，非网格）。 -->
        <v-list-item @click.stop="toggleStel('lines.ecliptic.visible')">
          <v-list-item-action>
            <v-switch value :input-value="getStel('lines.ecliptic.visible')" label=""></v-switch>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $t('Ecliptic Line') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <!-- [guanxing patch] 七政四余（M-QZ，用户需求）：开启后在黄道上显示
             四余虚拟点（罗睺/计都/紫炁/月孛，可点击），并把日月五星画布标签
             切为传统名（日/月/岁星/荧惑/镇星/太白/辰星）。开关状态存 Vuex
             （showQizhengSiyu），引擎侧由 swh.setQzsyEnabled 驱动，非引擎
             布尔属性，故不走 toggleStel。 -->
        <v-list-item @click.stop="toggleQizhengSiyu()">
          <v-list-item-action>
            <v-switch value :input-value="$store.state.showQizhengSiyu" label=""></v-switch>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>七政四余</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item @click.stop="toggleStel('constellations.images_visible')">
          <v-list-item-action>
            <v-switch value :input-value="getStel('constellations.images_visible')" label=""></v-switch>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $t('Constellations Art') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-menu>
    <!-- [guanxing patch] M-SW15：底栏星云类按钮按用户需求移除（引擎对应图层
         默认关闭，见 App.vue onReady 直写引擎属性）；数据源仍注册，
         信息卡对深空天体的展示能力不受影响。 -->
    <!-- [guanxing patch] M-SW25：底栏太阳系按钮（M-SW9）按用户需求移除——
         入口迁入星命弹窗「你出生时的太阳系」行（birth-fate-dialog view-solar
         → App.vue viewBirthSolar → showSolarSystemDialog），时刻定位改为
         出生瞬间（solar-system-dialog 按 solarSystemBirthIso 换算 ?t=）。
         M-SW45：按用户需求「下面的操作栏 添加一个按钮 跳转到 太阳系」再回到底栏。
         采用 A 方案：**与 M-SW25 的星命弹窗行并存**（两个入口共用同一个
         showSolarSystemDialog 开关，以及同一套出生时刻 ?t= 定位逻辑，不重复实现）。
         名字「本命太阳系」延续「本命」主题词（本命星命 / 你出生时的太阳系）。 -->
    <bottom-button label="本命太阳系"
                :img="require('@/assets/images/btn-solar-system.svg')"
                img_alt="Birth Solar System Button"
                :toggled="$store.state.showSolarSystemDialog"
                @clicked="openSolarSystem">
    </bottom-button>
    <!-- [guanxing patch] M-SW38：导出星图入口（用户需求「添加 导出独属于你的
         星图」+「添加截图功能」；先预览后手动下载，AskUserQuestion 定案）。
         生成逻辑在 star-map-export-dialog.vue，这里只翻 store 开关。 -->
    <bottom-button label="把这片星空带走"
                :img="require('@/assets/images/btn-camera.svg')"
                img_alt="Export star map Button"
                :toggled="$store.state.showStarMapExportDialog"
                @clicked="openStarMapExport">
    </bottom-button>
    <bottom-button :label="$t('Fullscreen')"
                :img="fullscreenBtnImage"
                img_alt="Fullscreen Button"
                class="hidden-xs-only"
                :toggled="$store.state.fullscreen"
                @clicked="(b) => { setFullscreen(b) }">
    </bottom-button>
    <!-- [guanxing patch] M-SW12b：底栏时间块（时钟显示+日期选择弹层）按用户
         需求「时间栏都去掉」整体移除，原时钟菜单在此；
         时间仍在流动，出生天象 ?date= 直达不受影响。 -->

    </div>
    <!-- [guanxing patch] 全屏不可用提示（M-SW3i）：全屏请求发出但未生效时给
         出可见反馈，取代原来的静默无反应。观星专属环境提示，固定简体中文。 -->
    <v-snackbar bottom left :timeout="4000" v-model="fsHint" color="secondary">
      当前运行环境不支持浏览器全屏（如嵌入预览窗口）。请在独立浏览器标签页中打开星临。
    </v-snackbar>
  </div>
</template>

<script>

import BottomButton from '@/components/bottom-button.vue'
import _ from 'lodash'
import swh from '@/assets/sw_helpers.js'

export default {
  components: { BottomButton },
  data: function () {
    return {
      showLayersMenu: false,
      // [guanxing patch] 视图设置菜单（M-SW7）：大气/地景/夜视三开关的弹出状态
      showViewMenu: false,
      // [guanxing patch] 全屏不可用提示（M-SW3i）：由 setFullscreen 的结果
      // 核实逻辑置 true，v-snackbar 展示后自动消失。
      fsHint: false
    }
  },
  computed: {
    // [guanxing patch] 当前星空文化是否为中国系（M-SW3b）。
    // chinese-28（二十八宿子集，M-SW4b）与 chinese-xingci（十二星次，M-SW62）
    // 也属中国系：两者都已是循环环内的独立一态，循环里先判它们再走本值
    // （isChinese 此时只剩 'chinese' 一意）。
    isChinese: function () {
      const sc = this.$store.state.skycultureId
      return sc === 'chinese' || sc === 'chinese-28' || sc === 'chinese-xingci'
    },
    // [guanxing patch] 五态循环按钮的标签随状态变化（M-SW3g 三态；M-SW15 二十八宿
    // 入环；M-SW62 十二星次入环）：连线关闭 → 星座连线；
    // 连线开 → 西方星座 / 中国星官 / 二十八宿 / 十二星次。
    constellationsLabel: function () {
      if (!this.$store.state.stel.constellations.lines_visible) return 'Constellations'
      if (this.$store.state.skycultureId === 'chinese-xingci') return '十二星次'
      if (this.$store.state.skycultureId === 'chinese-28') return '二十八宿'
      return this.isChinese ? 'Chinese constellations' : 'Western constellations'
    },
    fullscreenBtnImage: function () {
      return this.$store.state.fullscreen ? require('@/assets/images/svg/ui/fullscreen_exit.svg') : require('@/assets/images/svg/ui/fullscreen.svg')
    }
  },
  methods: {
    // [guanxing patch] 星空文化切换辅助（M-SW3b 引入，M-SW3g 抽出复用）：
    // 切 store 镜像 → 切引擎 current_id → 防御性重设连线/标签显隐
    // （引擎切换不复位 fader）。
    setSkyculture: function (next) {
      this.$store.commit('setValue', { varName: 'skycultureId', newValue: next })
      this.$stel.core.skycultures.current_id = next
      this.$stel.core.constellations.lines_visible = true
      this.$stel.core.constellations.labels_visible = true
    },
    // [guanxing patch] 七政四余开关（M-QZ，用户需求）：引擎侧由
    // swh.setQzsyEnabled 驱动（四余 circle 图层显隐 + 日月五星传统名标志），
    // Vuex 只做 UI 状态镜像。
    toggleQizhengSiyu: function () {
      this.$store.commit('toggleBool', 'showQizhengSiyu')
      swh.setQzsyEnabled(this.$stel, this.$store.state.showQizhengSiyu)
    },
    // [guanxing patch] 星座连线五态循环（M-SW3g 三态；M-SW15 用户需求把二十八宿
    // 并入循环；M-SW62 十二星次并入循环为第五态）：
    // 关闭 → 西方星座；西方 → 中国星官；中国星官 → 二十八宿；
    // 二十八宿 → 十二星次；十二星次 → 关闭连线。
    // 关闭时保留当前星空文化，只熄连线与标签。
    cycleConstellations: function () {
      const linesOn = this.$stel.core.constellations.lines_visible
      const sc = this.$store.state.skycultureId
      if (!linesOn) {
        this.setSkyculture('western')
      } else if (sc === 'chinese-xingci') {
        this.$stel.core.constellations.lines_visible = false
        this.$stel.core.constellations.labels_visible = false
      } else if (sc === 'chinese-28') {
        this.setSkyculture('chinese-xingci')
      } else if (this.isChinese) {
        this.setSkyculture('chinese-28')
      } else {
        this.setSkyculture('chinese')
      }
    },
    // [guanxing patch] 图层菜单行的引擎开关读写（M-SW3b 引入，M-SW3h 修复）：
    // store.state.stel 是 getTree() 的 JSON 快照，写入它不会传回引擎（用户报
    // 「点图层按钮没反应」的根因）——必须像上游 view-settings-dialog 一样直写
    // $stel.core（SweObj 属性是 defineProperty，set 即进引擎）；引擎值变化后
    // 由 onValueChanged 把快照同步回来，v-switch 的 input-value 自刷新。
    getStel: function (path) {
      return _.get(this.$store.state.stel, path)
    },
    toggleStel: function (path) {
      _.set(this.$stel.core, path, !_.get(this.$stel.core, path))
    },
    // [guanxing patch] 视图设置对话框入口（M-SW7 起在视图设置菜单内，原在
    // 图层菜单）：关两个菜单再开对话框，避免 menu 与 dialog 两层 overlay 叠加
    // （showLayersMenu 一并置 false 防御两入口并存时的叠加）。
    openViewSettings: function () {
      this.showViewMenu = false
      this.showLayersMenu = false
      this.$store.commit('toggleBool', 'showViewSettingsDialog')
    },
    // [guanxing patch] M-SW45：底栏「本命太阳系」入口（M-SW25 移除后按用户
    // 需求恢复）。与 openStarMapExport 同构：只翻 store 开关，渲染与出生时刻
    // 定位在 solar-system-dialog.vue（v-model 绑 $store.state.showSolarSystemDialog）。
    openSolarSystem: function () {
      this.showViewMenu = false
      this.showLayersMenu = false
      this.$store.commit('setValue', { varName: 'showSolarSystemDialog', newValue: true })
    },
    // [guanxing patch] M-SW38：导出星图入口。只翻 store 开关，截图与状态
    // 保存/恢复在 star-map-export-dialog.vue（watch 到打开即开始生成）。
    openStarMapExport: function () {
      this.showViewMenu = false
      this.showLayersMenu = false
      this.$store.commit('setValue', { varName: 'showStarMapExportDialog', newValue: true })
    },
    setFullscreen: function (b) {
      this.$fullscreen.toggle(document.body, {
        wrap: false,
        callback: this.onFullscreenChange
      })
      // [guanxing patch] 全屏请求结果核实（M-SW3i，用户报「点击全屏没反应」的根因）：
      // 嵌入 webview / 未授权 iframe 等环境里 requestFullscreen 的 Promise 会永久
      // 挂起（不 resolve 不 reject，实测对照：连「非用户手势」的拒绝都不返回），
      // fullscreenchange 永不触发，vue-fullscreen 对此完全静默，且 enter() 留在
      // body 上的 .fullscreen class 成为残留。这里在 500ms 后核实真实状态：
      // 真实浏览器中全屏在一帧内生效（照常返回）；未进入全屏则清残留并给出
      // 可见提示，取代原来的静默无反应。
      var that = this
      var sawFullscreen = false
      var onFsChange = function () { sawFullscreen = true }
      document.addEventListener('fullscreenchange', onFsChange)
      window.setTimeout(function () {
        document.removeEventListener('fullscreenchange', onFsChange)
        if (sawFullscreen || document.fullscreenElement) return
        document.body.classList.remove('fullscreen')
        that.fsHint = true
        console.warn('Fullscreen unavailable: 当前运行环境未实现浏览器全屏（常见于嵌入预览窗口或未授权 iframe）。请在独立浏览器标签页中打开星临。')
      }, 500)
    },
    setNightMode: function (b) {
      this.$store.commit('toggleBool', 'nightmode')
      if (window.navigator.userAgent.indexOf('Edge') > -1) {
        document.getElementById('nightmode').style.opacity = b ? '0.5' : '0'
      }
      document.getElementById('nightmode').style.visibility = b ? 'visible' : 'hidden'
    },
    onFullscreenChange: function (b) {
      if (this.$store.state.fullscreen === b) return
      this.$store.commit('toggleBool', 'fullscreen')
    }
  }
}
</script>

<style>
/* [guanxing patch] 底栏整合条（M-SW3d）：半透明深色圆角背景，贴合星空观感。
   [guanxing patch] M-SW12：换统一 token（深空蓝黑毛玻璃，与太阳系面板同材质），
   胶囊 999px 保留。
   [guanxing patch] M-SW46：按钮间加 gap（原 42px 宽按钮无缝相接，长标签溢出
   后与相邻按钮的标签重叠）；地点按钮下线后 bar-divider 一并移除。 */
.bar-shell {
  display: flex;
  align-items: center;
  gap: 6px;
  background: var(--gx-panel-bg);
  border: 1px solid var(--gx-panel-border);
  border-radius: 999px;
  padding: 4px 10px;
  margin-bottom: 8px;
  max-width: calc(100vw - 16px);
  box-shadow: var(--gx-shadow);
}
/* [guanxing patch] M-SW33：手机判定放宽为「短边≤600 且触屏」，手机横屏
   （宽>600px）不再掉回桌面布局。字面量须与 assets/phone-media.js 同步。 */
@media all and (max-width: 600px), (pointer: coarse) and (max-height: 600px) and (max-width: 1100px) {
  .bar-shell {
    gap: 4px;
    padding: 2px 6px;
  }
}

/* [guanxing patch] M-SW33：手机横屏时把「按宽度」的 Vuetify 响应类拽回手机态。
   底栏现有一处用 Vuetify 宽度类（模板里）：`hidden-xs-only`（全屏按钮，≥600px
   才显示；原地点名 span 与 hidden-sm-and-up 图标随 M-SW46 地点按钮下线移除）。
   手机横屏宽度 >600px 时 Vuetify 会把它切成桌面态，与「横屏也保持手机样式」
   冲突：全屏按钮会冒出来。这里在横屏手机条件下用更高优先级（html + 类，
   胜过 Vuetify 的单类 `!important`）覆写回手机态。 */
@media (pointer: coarse) and (max-height: 600px) and (max-width: 1100px) {
  html .hidden-xs-only { display: none !important; }
}
</style>
